(function () {
  if (window.mpnMainQty) return;
  var EXCL = 'cart-drawer, .drawer, dialog, pose-accessories, .pose-accessories, .mpn-so, cart-items, .cart-item, #main-cart-items, quick-add-modal, .quick-add-modal, .mpn-sticky-atc, sticky-add, .sticky-container';
  function num(v) {
    var n = parseFloat(String(v == null ? '' : v).replace(',', '.'));
    return isNaN(n) ? null : n;
  }
  function mainForms() {
    var forms = [].slice.call(document.querySelectorAll('form[action*="/cart/add"]')).filter(function (f) {
      return !f.closest(EXCL);
    });
    var main = forms.filter(function (f) { return /^product-form-.*main/i.test(f.id || ''); });
    var order = main.concat(forms.filter(function (f) { return main.indexOf(f) < 0 && /^product-form-/i.test(f.id || ''); }));
    return order.length ? order : forms;
  }
  function field(name) {
    var order = mainForms();
    for (var i = 0; i < order.length; i++) {
      var v = null;
      try { v = new FormData(order[i]).get(name); } catch (e) {}
      if (v !== null && v !== '') return v;
    }
    return null;
  }
  window.mpnMainQty = function () {
    var q = num(field('quantity'));
    if (q !== null && q >= 1) return q;
    var linked = document.querySelector('input[name="quantity"][form*="main"]') || document.querySelector('input[name="quantity"][form^="product-form"]');
    if (linked && !linked.closest(EXCL)) {
      var l = num(linked.value);
      if (l !== null && l >= 1) return l;
    }
    return 1;
  };
  window.mpnMainVariantId = function () {
    var v = field('id');
    if (v) return String(v);
    var u = new URLSearchParams(location.search).get('variant');
    return u ? String(u) : null;
  };

  function tidySoldBy() {
    document.querySelectorAll('.product__qty-infos:not(.mpn-lot-detail):not([data-mpn-qi])').forEach(function (el) {
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      var m = t.match(/\(([\s\S]+)\)\s*\.?$/);
      if (m && m[1].trim()) {
        var inner = m[1].trim();
        el.textContent = inner.charAt(0).toUpperCase() + inner.slice(1);
      } else {
        el.style.display = 'none';
      }
      el.setAttribute('data-mpn-qi', '1');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tidySoldBy); else tidySoldBy();
  new MutationObserver(function () { tidySoldBy(); }).observe(document.documentElement, { childList: true, subtree: true });

  /* Videos Shopify de la galerie */
  function quiet(v) {
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
    v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.loop = true; v.setAttribute('loop', '');
    if (window.matchMedia('(max-width: 749px)').matches && v.closest && v.closest('.product__media-list')) {
      /* Mobile : pas de barre de lecture (toucher = pause / lecture, bouton Agrandir = plein ecran) */
      v.controls = false; v.removeAttribute('controls'); v.disablePictureInPicture = true;
      v.__mpnCtl = true; /* la barre de lecture ajoutee par mpn-v8-fixes (videoCtl) ne s'applique pas */
    } else {
      v.controls = true; v.setAttribute('controls', ''); v.setAttribute('controlsList', 'nodownload nofullscreen noremoteplayback'); v.disablePictureInPicture = true;
    }
    v.setAttribute('preload', 'metadata');
  }
  function play(v) { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); }
  function load(dm) {
    if (dm.getAttribute('loaded')) return;
    var tpl = dm.querySelector('template');
    var node = tpl && tpl.content.firstElementChild ? tpl.content.firstElementChild.cloneNode(true) : null;
    if (!node) return;
    var vid = node.nodeName === 'VIDEO' ? node : node.querySelector('video');
    if (vid) quiet(vid);
    dm.appendChild(node);
    dm.setAttribute('loaded', true);
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var dm = en.target;
      if (en.isIntersecting) {
        load(dm);
        dm.querySelectorAll('video').forEach(function (v) { quiet(v); play(v); });
      } else {
        dm.querySelectorAll('video').forEach(function (v) { if (v.pause) v.pause(); });
      }
    });
  }, { threshold: 0.4 }) : null;
  function autoVideos() {
    document.querySelectorAll('media-gallery deferred-media:not(.mpn-autovid)').forEach(function (dm) {
      var tpl = dm.querySelector('template');
      var hasVideo = (tpl && tpl.content && tpl.content.querySelector('video')) || dm.querySelector('video');
      if (!hasVideo) return;
      dm.classList.add('mpn-autovid');
      if (io) io.observe(dm); else { load(dm); dm.querySelectorAll('video').forEach(function (v) { quiet(v); play(v); }); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoVideos); else autoVideos();
  window.addEventListener('load', autoVideos);
  setTimeout(autoVideos, 1500);

  /* Bouton echantillon / surface test : ajout + rechargement complet du tiroir panier Mineral */
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.sample-button[data-sample-variant-id]');
    if (!btn) return;
    var d = document.querySelector('cart-drawer.mpn-cd');
    if (!d) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.classList.contains('loading')) return;
    var id = btn.getAttribute('data-sample-variant-id');
    var spin = btn.querySelector('.loading__spinner');
    btn.classList.add('loading'); if (spin) spin.classList.remove('hidden');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status && res.description) { alert(res.description); return; }
      return fetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
        var src = s['cart-drawer'] && parse(s['cart-drawer']).querySelector('.drawer__inner');
        var dst = d.querySelector('.drawer__inner');
        if (src && dst) dst.innerHTML = src.innerHTML;
        d.classList.remove('is-empty');
        var bub = document.getElementById('cart-icon-bubble');
        var sb = s['cart-icon-bubble'] && parse(s['cart-icon-bubble']).querySelector('.shopify-section');
        if (bub && sb) bub.innerHTML = sb.innerHTML;
        if (dst) dst.scrollTop = 0;
        d.productId = id;
        if (typeof d.open === 'function') d.open(); else d.classList.add('active');
        if (window.publish && window.PUB_SUB_EVENTS) { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sample-button', productVariantId: id }); } catch (x) {} }
      });
    }).catch(function () {}).finally(function () {
      btn.classList.remove('loading'); if (spin) spin.classList.add('hidden');
    });
  }, true);
})();
